// import React, { useState } from "react";
// import HeaderInner from "../../utility/HeaderInner";

// const BookMeeting = () => {
//   const morningSlots = [
//     "9:00 AM",
//     "9:30 AM",
//     "10:00 AM",
//     "10:30 AM",
//     "11:00 AM",
//     "11:30 AM",
//   ];

//   const afternoonSlots = [
//     "1:00 PM",
//     "1:30 PM",
//     "2:00 PM",
//     "2:30 PM",
//     "3:00 PM",
//     "3:30 PM",
//     "4:00 PM",
//     "4:30 PM",
//   ];

//   const generateMonths = (count = 12) => {
//     const now = new Date();
//     const monthsArr = [];
//     for (let i = 0; i < count; i++) {
//       const date = new Date(now.getFullYear(), now.getMonth() + i, 1);
//       monthsArr.push(
//         date.toLocaleDateString("en-US", { month: "long", year: "numeric" })
//       );
//     }
//     return monthsArr;
//   };

//   const months = generateMonths(4);
//   const [selectedMonth, setSelectedMonth] = useState(months[0]);
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [selectedTime, setSelectedTime] = useState(null);

//   // Generate dates dynamically, skipping expired ones
//   const generateDates = (monthYear) => {
//     const today = new Date();
//     const [month, year] = monthYear.split(" ");
//     const monthIndex = new Date(`${month} 1, ${year}`).getMonth();
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     const datesArr = [];
//     for (let day = 1; day <= daysInMonth; day++) {
//       const dateObj = new Date(year, monthIndex, day);

//       // skip past dates in current month
//       if (
//         monthIndex === today.getMonth() &&
//         parseInt(year) === today.getFullYear() &&
//         day < today.getDate()
//       ) {
//         continue;
//       }

//       const dayName = dateObj.toLocaleDateString("en-US", { weekday: "short" });
//       const fullDate = dateObj.toLocaleDateString("en-US", {
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//       });

//       const isWeekend = dateObj.getDay() === 0 || dateObj.getDay() === 6;

//       datesArr.push({
//         day: dayName,
//         date: fullDate,
//         disabled: isWeekend, // only weekends disabled
//       });
//     }
//     return datesArr;
//   };

//   const dates = generateDates(selectedMonth);

//   return (
//     <div className="mt-120 mb-10">
//       <HeaderInner
//         title={"Booking Meeting"}
//         shortDescription={"Get in touch with Coempt Edu Teck across India"}
//       />
//       <div className="container ">
//         {/* Header */}
//         {/* <div className="d-flex flex-row align-items-center justify-content-between">
//           <span className="fs-5 text-black fw-semibold">
//             Consultation meeting
//           </span>
//           <span className="text-black fs-6">30 minutes</span>
//         </div> */}

//         {/* Month Selector */}
//         <div className="mt-5">
//           <label className="fw-semibold fs-6 me-2">Select Month:</label>
//           <select
//             className="form-select w-auto d-inline-block"
//             value={selectedMonth}
//             onChange={(e) => {
//               setSelectedMonth(e.target.value);
//               setSelectedDate(null);
//               setSelectedTime(null);
//             }}
//           >
//             {months.map((m, idx) => (
//               <option key={idx} value={m}>
//                 {m}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Date Selector */}
//         <h6 className="mt-4 mb-3">Select a date</h6>
//         <div className="d-flex overflow-auto gap-3 pb-3">
//           {dates.map((item, index) => (
//             <div
//               key={index}
//               className="card text-center flex-shrink-0 px-3 py-2"
//               style={{
//                 minWidth: "150px",
//                 cursor: item.disabled ? "not-allowed" : "pointer",
//                 backgroundColor:
//                   selectedDate === item.date
//                     ? "#0a1530"
//                     : item.disabled
//                     ? "#f1f1f1"
//                     : "#fff",
//                 color:
//                   selectedDate === item.date
//                     ? "#fff"
//                     : item.disabled
//                     ? "#999"
//                     : "#0a1530",
//                 border: item.disabled ? "1px solid #ddd" : "1px solid #0a1530",
//                 boxShadow:
//                   selectedDate === item.date
//                     ? "0 2px 6px rgba(0,0,0,0.2)"
//                     : "0 1px 4px rgba(0,0,0,0.1)",
//               }}
//               onClick={() => !item.disabled && setSelectedDate(item.date)}
//             >
//               <strong>{item.day}</strong>
//               <div style={{ fontSize: "14px" }}>{item.date}</div>
//             </div>
//           ))}
//         </div>

//         {/* Time Selector */}
//         {selectedDate && (
//           <div className="mt-2 w-100">
//             <h6 className="mb-2">Select a time on {selectedDate}</h6>

//             <div className="d-flex flex-wrap gap-4 w-100">
//               {/* Morning */}
//               <div
//                 className="d-flex flex-column p-3"
//                 style={{ flex: "1 1 250px", minWidth: "250px" }}
//               >
//                 <div className="mb-2 fw-semibold">Morning</div>
//                 <div className="d-flex flex-wrap gap-2">
//                   {morningSlots.map((time, index) => (
//                     <div
//                       key={index}
//                       className="px-3 py-2 rounded text-center"
//                       style={{
//                         minWidth: "110px",
//                         cursor: "pointer",
//                         border:
//                           selectedTime === time
//                             ? "2px solid #0a1530"
//                             : "1px solid #ccc",
//                         backgroundColor:
//                           selectedTime === time ? "#0a1530" : "#fff",
//                         color: selectedTime === time ? "#fff" : "#0a1530",
//                         transition: "all 0.2s ease",
//                       }}
//                       onClick={() => setSelectedTime(time)}
//                     >
//                       {time}
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Afternoon */}
//               <div
//                 className="d-flex flex-column p-3"
//                 style={{ flex: "1 1 250px", minWidth: "250px" }}
//               >
//                 <div className="mb-2 fw-semibold">Afternoon</div>
//                 <div className="d-flex flex-wrap gap-2 w-100">
//                   {afternoonSlots.map((time, index) => (
//                     <div
//                       key={index}
//                       className="px-3 py-2 rounded text-center"
//                       style={{
//                         minWidth: "110px",
//                         cursor: "pointer",
//                         border:
//                           selectedTime === time
//                             ? "2px solid #0a1530"
//                             : "1px solid #ccc",
//                         backgroundColor:
//                           selectedTime === time ? "#0a1530" : "#fff",
//                         color: selectedTime === time ? "#fff" : "#0a1530",
//                         transition: "all 0.2s ease",
//                       }}
//                       onClick={() => setSelectedTime(time)}
//                     >
//                       {time}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {selectedTime && (
//           <div className="talk-us__item mt-5">
//             {/* Selected Date & Time */}
//             <div className="text-white mb-3">
//               <div className="fw-bold fs-4">
//                 You are booking: Consultation meeting
//               </div>
//               <div className="fs-6">
//                 {selectedDate} {selectedTime} - 9:30 am Asia/Calcutta
//               </div>
//             </div>

//             {/* Form */}
//             <form action="#">
//               <div className="row g-3">
//                 <div className="">
//                   <label htmlFor="name" className="text-white">
//                     Your Name*
//                   </label>
//                   <input
//                     type="text"
//                     id="name"
//                     placeholder="Your name"
//                     className="form-control"
//                   />
//                 </div>
//                 <div className="">
//                   <label htmlFor="email" className="text-white">
//                     Your Email*
//                   </label>
//                   <input
//                     type="email"
//                     id="email"
//                     placeholder="Email"
//                     className="form-control"
//                   />
//                 </div>
//                 <div className="">
//                   <label htmlFor="number" className="text-white">
//                     Your Phone*
//                   </label>
//                   <input
//                     type="text"
//                     id="number"
//                     placeholder="Your Phone"
//                     className="form-control"
//                   />
//                 </div>
//                 <div className="col-12">
//                   <label htmlFor="message" className="text-white">
//                     Message*
//                   </label>
//                   <textarea
//                     id="message"
//                     placeholder="Write Message"
//                     className="form-control"
//                     rows="4"
//                   />
//                 </div>
//               </div>

//               <button type="submit" className="btn btn-primary mt-3">
//                 BOOK THIS APPOINMENT
//               </button>
//             </form>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default BookMeeting;

import React from "react";

const BookMeeting = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center">
      <h1 className="display-3 text-primary mb-4">🚧 Coming Soon</h1>
      <p className="lead text-secondary mb-4">
        We’re working hard to bring you something amazing. Stay tuned!
      </p>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default BookMeeting;
